var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5003 21.9998L20.167 25.6665L28.417 17.4165M13.4456 7.00078C14.9193 6.88318 16.3183 6.30368 17.4435 5.34477C20.0693 3.10708 23.9313 3.10708 26.5571 5.34477C27.6823 6.30368 29.0814 6.88318 30.5551 7.00078C33.9941 7.27521 36.7249 10.0061 36.9994 13.4451C37.117 14.9188 37.6965 16.3178 38.6554 17.443C40.8931 20.0688 40.8931 23.9308 38.6554 26.5566C37.6965 27.6819 37.117 29.0809 36.9994 30.5546C36.7249 33.9936 33.9941 36.7245 30.5551 36.9989C29.0814 37.1165 27.6823 37.696 26.5571 38.6549C23.9313 40.8926 20.0693 40.8926 17.4435 38.6549C16.3183 37.696 14.9193 37.1165 13.4456 36.9989C10.0066 36.7245 7.2757 33.9936 7.00127 30.5546C6.88367 29.0809 6.30416 27.6819 5.34526 26.5566C3.10757 23.9308 3.10757 20.0688 5.34526 17.443C6.30416 16.3178 6.88367 14.9188 7.00127 13.4451C7.2757 10.0061 10.0066 7.27521 13.4456 7.00078Z",
    stroke: "#4D9DFF",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.26fe02eb20fe635dad3bc01b6142d5fa.svg";
export { ForwardRef as ReactComponent };